import React from 'react'

export default function Error() {
    return (
        <div>
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.7523 22.5H29.2523V33.75H24.7523V22.5ZM24.75 36H29.25V40.5H24.75V36Z" fill="#BB0600" />
                <path d="M30.9781 9.45005C30.1951 7.9763 28.6696 7.06055 27.0001 7.06055C25.3306 7.06055 23.8051 7.9763 23.0221 9.4523L6.51163 40.644C6.14526 41.329 5.96377 42.0977 5.98508 42.8742C6.00639 43.6507 6.22975 44.4082 6.63313 45.072C7.0307 45.7389 7.59532 46.2905 8.27124 46.6725C8.94716 47.0545 9.71101 47.2535 10.4874 47.25H43.5129C45.1059 47.25 46.5481 46.4355 47.3694 45.072C47.7721 44.408 47.9951 43.6505 48.0164 42.8741C48.0377 42.0978 47.8566 41.3292 47.4909 40.644L30.9781 9.45005ZM10.4874 42.75L27.0001 11.5583L43.5241 42.75H10.4874Z" fill="#BB0600" />
            </svg>
        </div>
    )
}
